import { render } from "./Index.vue?vue&type=template&id=22518ea6&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=22518ea6&scoped=true&lang=css"

import exportComponent from "/var/docker/processing-orders/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22518ea6"]])

export default __exports__